// extracted by mini-css-extract-plugin
export default {"root":"AssessmentProgress_root__YOyuE"};